module.exports = __webpack_public_path__ + "img/ins-notes.e5024793.svg";